var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white",
    stroke: "#EE4D2D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32284_40881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.61538,
    y: 1.61538,
    width: 30.7692,
    height: 30.7692,
    rx: 15.3846,
    fill: "#EE4D2D",
    stroke: "#EE4D2D",
    strokeWidth: 1.23077
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32284_40881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 17H24.1112L23.2778 20.5556H10.7778V17Z",
    fill: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8787 7.22217H24.1111V11.3799H21.6868C20.0707 11.3799 19.2626 12.2114 19.2626 13.8745V32.9999H15.2222V13.4587C15.2222 9.71679 17.6464 7.22217 20.8787 7.22217Z",
    fill: "#EE4D2D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1177c15fb0acce2b0a8f86401a455bf5.svg";
export { ForwardRef as ReactComponent };